import { EMPTY_OBJECT } from '../../../constants/common'

export function checkHasDashboardListRowSubtitleContent({
  Subtitle,
  subtitleProps,
}) {
  return (
    !!Subtitle && Object.values(subtitleProps ?? EMPTY_OBJECT).some(Boolean)
  )
}

export function checkHasDashboardListRowSubtitleLine({
  hasSubtitleContent,
  statusProps,
  subtitle,
}) {
  return !!(hasSubtitleContent || statusProps || subtitle)
}

export function checkHasDashboardListRowStatusDot({
  hasSubtitleContent,
  statusProps,
  subtitle,
}) {
  return !!(statusProps && (hasSubtitleContent || subtitle))
}
